import(/* webpackMode: "eager", webpackExports: ["AuthProviders"] */ "/home/runner/work/highrays-yt/highrays-yt/src/app/(public)/auth/auth_providers.tsx");
